export default __webpack_public_path__ + "static/media/shea_with_patient.e6ad06f4.jpg";